import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerDeliveryEdit = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [orderId, setOrderId] = useState(0);
  const [order, setOrder] = useState(null);
  const [orderStatus, setOrderStatus] = useState('');
  const [isNewDelivery, setIsNewDelivery] = useState(false);
  const [couriers, setCouriers] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState('');
  const [saveMsg, setSaveMsg] = useState('');
  const [statusMsg, setStatusMsg] = useState('');

  const [form, setForm] = useState({
    receiver_name: '',
    receiver_phone: '',
    address: '',
    courier: '',
    tracking_number: '',
  });

  const [statusForm, setStatusForm] = useState({
    delivery_status: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const oid = Number(new URLSearchParams(window.location.search).get('order_id') || 0);

        const res = await axios.get(
          `/api/seller/delivery/edit-data?order_id=${encodeURIComponent(oid)}`,
          { withCredentials: true }
        );

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setOrderId(res.data.order_id || 0);
          setOrder(res.data.order || null);
          setOrderStatus(res.data.order_status || '');
          setIsNewDelivery(!!res.data.is_new_delivery);
          setCouriers(res.data.couriers || {});
          setStatuses(Array.isArray(res.data.statuses) ? res.data.statuses : []);
          setCurrentStatus(res.data.current_status || '');

          const d = res.data.delivery || {};
          setForm({
            receiver_name: d.receiver_name || '',
            receiver_phone: d.receiver_phone || '',
            address: d.address || '',
            courier: d.courier || '',
            tracking_number: d.tracking_number || '',
          });

          setStatusForm({
            delivery_status: res.data.current_status || '',
          });
        } else {
          alert(res.data?.error || '배송 정보를 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;
        if (redirect) {
          window.location.href = redirect;
          return;
        }
        alert(error || '배송 정보를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setStatusForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveDelivery = async (e) => {
    e.preventDefault();
    setSaveMsg('');

    try {
      const res = await axios.post(
        '/api/seller/delivery/update-json',
        {
          order_id: orderId,
          is_new_delivery: isNewDelivery ? '1' : '0',
          receiver_name: form.receiver_name,
          receiver_phone: form.receiver_phone,
          address: form.address,
          courier: form.courier,
          tracking_number: form.tracking_number,
        },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setSaveMsg('success');
        setTimeout(() => {
          window.location.href = res.data.redirect || `/seller/delivery/edit?order_id=${orderId}`;
        }, 300);
        return;
      }

      setSaveMsg(res.data?.msg || '저장 실패');
    } catch (err) {
      setSaveMsg(err?.response?.data?.msg || '저장 실패');
    }
  };

  const handleUpdateStatus = async (e) => {
    e.preventDefault();
    setStatusMsg('');

    try {
      const res = await axios.post(
        '/api/seller/delivery/status-json',
        {
          order_id: orderId,
          delivery_status: statusForm.delivery_status,
        },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setStatusMsg('success');
        setTimeout(() => {
          window.location.href = res.data.redirect || `/seller/delivery/edit?order_id=${orderId}`;
        }, 300);
        return;
      }

      setStatusMsg(res.data?.msg || '상태 변경 실패');
    } catch (err) {
      setStatusMsg(err?.response?.data?.msg || '상태 변경 실패');
    }
  };

  const renderTopStatus = () => {
    if (orderStatus === '주문취소') {
      return (
        <>
          <span style={styles.badgeDanger}>주문취소</span>
          {order?.paymentkey ? (
            <form method="post" action="/bill/manage_receipt" target="_blank" style={styles.inlineForm}>
              <input type="hidden" name="paykey" value={order.paymentkey} />
              <button type="submit" style={styles.inlineLinkBtn}>[상세정보]</button>
            </form>
          ) : null}
        </>
      );
    }

    if (currentStatus === '배송완료') {
      return <span style={styles.badgeSuccess}>배송완료</span>;
    }

    if (currentStatus === '배송중') {
      return (
        <>
          <span style={styles.badgeInfo}>배송중</span>
          {form.courier && form.tracking_number ? (
            <form method="get" action="/seller/tracking/view" target="_blank" style={styles.inlineForm}>
              <input type="hidden" name="courier" value={form.courier} />
              <input type="hidden" name="tracking_number" value={form.tracking_number} />
              <button type="submit" style={styles.inlineLinkBtn}>[배송조회]</button>
            </form>
          ) : null}
        </>
      );
    }

    if (currentStatus === '배송준비중') {
      return <span style={styles.badgeWarning}>배송준비중</span>;
    }

    return <span style={styles.badgePrimary}>결제완료</span>;
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.topSpace}></div>
      <h3 style={styles.title}>주문번호 #{orderId} 배송 정보 관리</h3>

      <div style={styles.statusBox}>
        <strong>주문내역 상태표시:</strong> {renderTopStatus()}
      </div>

      {isNewDelivery ? (
        <>
          <div style={styles.infoAlert}>이 주문에는 배송 정보가 없습니다. 아래 폼을 작성하여 새로 등록하세요.</div>
          <span style={styles.badgeDangerFixed}>배송 정보 없음</span>
        </>
      ) : (
        <span style={styles.badgeSuccessFixed}></span>
      )}

      <form onSubmit={handleSaveDelivery} style={styles.form}>
        <input type="hidden" name="order_id" value={orderId} />
        <input type="hidden" name="is_new_delivery" value={isNewDelivery ? '1' : '0'} />

        <div style={styles.mb3}>
          <label style={styles.label}>수령인 이름</label>
          <input
            type="text"
            name="receiver_name"
            value={form.receiver_name}
            onChange={handleChange}
            style={styles.input}
            required
          />
        </div>

        <div style={styles.mb3}>
          <label style={styles.label}>전화번호</label>
          <input
            type="text"
            name="receiver_phone"
            value={form.receiver_phone}
            onChange={handleChange}
            style={styles.input}
            required
          />
        </div>

        <div style={styles.mb3}>
          <label style={styles.label}>주소</label>
          <textarea
            name="address"
            value={form.address}
            onChange={handleChange}
            style={styles.textarea}
            required
          />
        </div>

        <div style={styles.mb3}>
          <label style={styles.label}>택배사</label>
          <select
            name="courier"
            value={form.courier}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">-- 택배사를 선택하세요 --</option>
            {Object.entries(couriers).map(([code, name]) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.mb3}>
          <label style={styles.label}>송장번호</label>
          <input
            type="text"
            name="tracking_number"
            value={form.tracking_number}
            onChange={handleChange}
            style={styles.input}
          />
        </div>

        <button type="submit" style={styles.primaryBtn}>배송 정보 저장</button>

        {saveMsg === 'success' ? (
          <div style={styles.successAlert}>배송 정보가 저장되었습니다.</div>
        ) : saveMsg ? (
          <div style={styles.dangerAlert}>{saveMsg}</div>
        ) : null}
      </form>

      <hr style={styles.hr} />

      <form onSubmit={handleUpdateStatus} style={styles.mt4}>
        <input type="hidden" name="order_id" value={orderId} />

        <div style={styles.mb3}>
          <label style={styles.label}>배송 상태 변경</label>
          <select
            name="delivery_status"
            value={statusForm.delivery_status}
            onChange={handleStatusChange}
            style={styles.select}
            required
          >
            <option value="" disabled>-- 선택하세요 --</option>
            {statuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" style={styles.warningBtn}>배송 상태 변경</button>

        {statusMsg === 'success' ? (
          <div style={styles.successAlert}>배송 상태가 변경되었습니다.</div>
        ) : statusMsg ? (
          <div style={styles.dangerAlert}>{statusMsg}</div>
        ) : null}
      </form>
    </SellerLayout>
  );
};

const styles = {
  loading: { padding: '40px 0' },
  topSpace: { height: '8px' },
  title: { marginBottom: '16px' },
  statusBox: { marginBottom: '16px' },
  inlineForm: { display: 'inline', margin: 0, padding: 0 },
  inlineLinkBtn: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    marginLeft: '8px',
    fontSize: '12px',
    color: '#000',
    cursor: 'pointer',
  },
  badgePrimary: {
    display: 'inline-block',
    background: '#0d6efd',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeSuccess: {
    display: 'inline-block',
    background: '#198754',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeInfo: {
    display: 'inline-block',
    background: '#0dcaf0',
    color: '#212529',
    borderRadius: '999px',
    padding: '4px 8px',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeWarning: {
    display: 'inline-block',
    background: '#ffc107',
    color: '#212529',
    borderRadius: '999px',
    padding: '4px 8px',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  badgeDanger: {
    display: 'inline-block',
    background: '#dc3545',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  infoAlert: {
    padding: '12px 14px',
    borderRadius: '8px',
    background: '#cff4fc',
    color: '#055160',
    border: '1px solid #b6effb',
    marginBottom: '8px',
  },
  badgeDangerFixed: {
    display: 'inline-block',
    minWidth: '80px',
    textAlign: 'center',
    background: '#dc3545',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  badgeSuccessFixed: {
    display: 'inline-block',
    minWidth: '80px',
    textAlign: 'center',
    background: '#198754',
    color: '#fff',
    borderRadius: '999px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  form: {
    marginTop: '16px',
  },
  mt4: {
    marginTop: '24px',
  },
  mb3: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 600,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    minHeight: '120px',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
    resize: 'vertical',
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  primaryBtn: {
    padding: '10px 14px',
    border: 'none',
    borderRadius: '6px',
    background: '#0d6efd',
    color: '#fff',
    cursor: 'pointer',
  },
  warningBtn: {
    padding: '10px 14px',
    border: 'none',
    borderRadius: '6px',
    background: '#ffc107',
    color: '#212529',
    cursor: 'pointer',
  },
  successAlert: {
    marginTop: '12px',
    padding: '10px 12px',
    borderRadius: '8px',
    background: '#d1e7dd',
    color: '#0f5132',
    border: '1px solid #badbcc',
  },
  dangerAlert: {
    marginTop: '12px',
    padding: '10px 12px',
    borderRadius: '8px',
    background: '#f8d7da',
    color: '#842029',
    border: '1px solid #f5c2c7',
  },
  hr: {
    margin: '24px 0',
    border: 0,
    borderTop: '1px solid #dee2e6',
  },
};

export default SellerDeliveryEdit;